import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { makeGetProductFulfillment, makeGetProductFulfillmentBySize } from '../redux/product/selectors/ProductSelector';
import { OnlineAvailability } from '../components/product-detail/online-availability/OnlineAvailability';
const OnlineAvailabilityContainer = ({ hdExcluded, ccExcluded, fulfillmentCopyDescription, fulfillmentBySize: { storeSourceExcluded }, }) => (_jsx(OnlineAvailability, { hdExcluded: hdExcluded, ccExcluded: ccExcluded, storeSourceExcluded: storeSourceExcluded, fulfillmentCopyDescription: fulfillmentCopyDescription }));
const makeMapStateToProps = () => {
    const getProductFulfillment = makeGetProductFulfillment();
    const getProductFulfillmentBySize = makeGetProductFulfillmentBySize();
    const mapStateToProps = (state) => ({
        hdExcluded: getProductFulfillment(state).hdExcluded,
        ccExcluded: getProductFulfillment(state).ccExcluded,
        fulfillmentCopyDescription: getProductFulfillment(state).fulfillmentCopyDescription,
        fulfillmentBySize: getProductFulfillmentBySize(state),
    });
    return mapStateToProps;
};
export default connect(makeMapStateToProps)(OnlineAvailabilityContainer);
